import dayjs from 'dayjs';
import Cookies from 'universal-cookie';
import 'dayjs/locale/el';
dayjs.locale('el');
const cookies = {
  el: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: 'session',
        name: 'PHPSESSID',
        description: 'Διατηρεί την κατάσταση της σύνδεσης χρήστη σε όλα τα αιτήματα σελίδας.',
        origin: process.env.appName,
      },
      // {
      //   id: 2,
      //   duration: '12 μήνες',
      //   name: '__zlcmid',
      //   description: 'Χρησιμοποιείται για την άμεση επικοινωνία με το customer support.',
      //   origin: process.env.appName,
      // },
      {
        id: 3,
        duration: '15 ημέρες',
        name: 'token',
        description: 'Διατηρεί την κατάσταση σύνδεσης του χρήστη στον ιστότοπο',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: 'session',
        name: 'JSESSIONID',
        description: 'Διατηρεί την επιλογή του χρήστη για την χρήση των cookies',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: 'until deleted by user (delete cache)',
        name: 'productForOrder',
        description: 'Διατηρεί τα προϊόντα στο καλάθι της παραγγελίας του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: 'until deleted by user (delete cache)',
        name: 'productQuantities',
        description: 'Διατηρεί τις ποσότητες των προϊόντων στο καλάθι της παραγγελίας του χρήστη',
        origin: process.env.appName,
      },
      // {
      //   id: 7,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'order',
      //   description: 'Διατηρεί τις επιλογές του χρήστη  όσον αφορά την παραγγελίας του',
      //   origin: process.env.appName,
      // },
      // {
      //   id: 8,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'DeliveryMode',
      //   description: 'Διατηρεί την επιλογή του χρήστη  όσον αφορά την υπηρεσία',
      //   origin: process.env.appName,
      // },
      {
        id: 9,
        duration: 'until deleted by user (delete cache)',
        name: 'PostalCode',
        description:
          'Διατηρεί την επιλογή του χρήστη  όσον αφορά τον ταχυδρομικό του κώδικα για την προβολή των διαθέσιμων υπηρεσιών',
        origin: process.env.appName,
      },
      // {
      //   id: 10,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'isAddressRegistered',
      //   description: 'Διατηρεί αν ο χρήστης έχει υποβάλει πληροφορίες για τον ταχυδρομικό του κώδικα',
      //   origin: process.env.appName,
      // },
      {
        id: 11,
        duration: 'until deleted by user (delete cache)',
        name: `${process.env.appName}:privacy`,
        description: 'Διατηρεί τις επιλογές του χρήστη για την αποδοχή των cοοkies',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: 'until deleted by user (delete cache)',
        name: 'Shop',
        description: 'Διατηρεί το κατάστημα που εξηπυρετεί τον χρήστη',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: 'until deleted by user (delete cache)',
        name: 'loginProvider',
        description: 'Διατηρεί τον τρόπο εισόδου του χρήστη στην εφαρμογή',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: 'until deleted by user (delete cache)',
        name: 'pickupMethod',
        description: 'Διατηρεί την επιλογή υπηρεσίας παράδοσης/παραλαβής του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrer',
        description:
          'Εντοπίζει τον τρόπο με τον οποίο ο χρήστης έφτασε στον ιστότοπο καταχωρίζοντας την τελευταία του διεύθυνση URL.',
        origin: '	Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrerTime',
        description:
          'Εντοπίζει τον τρόπο με τον οποίο ο χρήστης έφτασε στον ιστότοπο καταχωρίζοντας την τελευταία του διεύθυνση URL.',
        origin: '	Meta Platforms, Inc.',
      },
      {
        id: 18,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedUserAddressIndex',
        description: 'Διατηρεί την επιλογή διεύθυνσης του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 19,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedTakeAwayStoreIndex',
        description: 'Διατηρεί την επιλογή καταστήματος του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 20,
        duration: 'until deleted by user (delete cache)',
        name: 'generalSelectedTimeslot',
        description: 'Διατηρεί την επιλογή timeslot του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 21,
        duration: 'until deleted by user (delete cache)',
        name: 'SelectedShopId',
        description: 'Διατηρεί το id του καταστήματος που εξηπυρετεί τον χρήστη',
        origin: process.env.appName,
      },
      {
        id: 22,
        duration: 'until deleted by user (delete cache)',
        name: 'user',
        description: 'Διατηρεί πληροφορίες για το λογαριασμό του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 23,
        duration: 'until deleted by user (delete cache)',
        name: 'prebook',
        description: 'Διατηρεί πληροφορίες για το προεπιλεγμένο από τον χρήστη timeslot',
        origin: process.env.appName,
      },
      {
        id: 24,
        duration: 'until deleted by user (delete cache)',
        name: 'firstSelectedTimeslot',
        description: 'Διατηρεί την επιλογή timeslot του χρήστη',
        origin: process.env.appName,
      },
      {
        id: 25,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedBundleOffer',
        description: 'Διατηρεί την επιλογή συνδιαστικής προσφοράς από τον χρήστη',
        origin: process.env.appName,
      },
      {
        id: 26,
        duration: 'until deleted by user (delete cache)',
        name: 'cart',
        description: 'Διατηρεί πληροφορίες σχετικά με το καλάθι που έχει ετοιμάσει ο χρήστης',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: 'session',
        name: '_gat_UA-105613924-4',
        description: 'Καταχωρεί ένα μοναδικό αναγνωριστικό για την εταιρία του ιστότοπου',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2 ημέρες',
        name: '_gid',
        description:
          'Καταχωρεί ένα μοναδικό αναγνωριστικό που χρησιμοποιείται για τη δημιουργία στατιστικών στοιχείων σχετικά με τον τρόπο με τον οποίο ο επισκέπτης χρησιμοποιεί τον ιστότοπο.',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24 μήνες',
        name: '_ga',
        description: 'Χρησιμοποιείται από το Google Analytics για να ρυθμίσει την ταχύτητα του αιτήματος',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6 μήνες',
        name: 'NID',
        description:
          'Το cookie NID περιέχει ένα μοναδικό αναγνωριστικό που χρησιμοποιεί η Google για να θυμάται τις προτιμήσεις σας και άλλες πληροφορίες.',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24 μήνες',
        name: 'CONSENT',
        description:
          'Η λειτουργία συναίνεσης σάς επιτρέπει να προσαρμόσετε τον τρόπο συμπεριφοράς των ετικετών σας Google με βάση την κατάσταση συναίνεσης των χρηστών σας.',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30 μέρες',
        name: '1P_JAR',
        description:
          'Αυτά τα cookie χρησιμοποιούνται για τη συλλογή στατιστικών στοιχείων ιστότοπου και την παρακολούθηση των ποσοστών μετατροπών.',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1 μέρα',
        name: 'DV',
        description:
          'Αυτό το cookie χρησιμοποιείται για την αποθήκευση των προτιμήσεων του χρήστη και άλλων πληροφοριών.',
        origin: 'Google',
      },
    ],
    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12 μήνες',
            name: 'bi',
            description:
              'Χρησιμοποιείται ως συμβολοσειρά αναγνώρισης για την περίοδο σύνδεσης του επισκέπτη. Είναι μια συμβολοσειρά GUID.',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12 μήνες',
            name: 'cpab',
            description:
              'Αυτό το cookie λειτουργεί προκειμένου να σας παρέχει μία εξατομικευμένη εμπειρία στο Κατάστημα',
            origin: 'Contact Pigeon',
          },
          {
            id: 3,
            duration: '12 μήνες',
            name: 'cp_sessionTime',
            description:
              'Περιέχει την χρονική σήμανση της τελευταίας σελίδας επίσκεψης του επισκέπτη σε χιλιοστά του δευτερολέπτου.',
            origin: 'Contact Pigeon',
          },
          {
            id: 4,
            duration: '12 μήνες',
            name: 'cp_total_cart_value',
            description:
              'Περιέχει την τρέχουσα κατάσταση καλαθιού του επισκέπτη με το τρέχον περιεχόμενο που περιέχει τη συνολική αξία.',
            origin: 'Contact Pigeon',
          },
          {
            id: 5,
            duration: 'Session',
            name: 'cp_shownnotscookie',
            description: 'Κρατάει πληροφορία για εάν ο χρήστης επιθύμει notifications στο browser του',
            origin: 'Contact Pigeon',
          },
          {
            id: 6,
            duration: '12 μήνες',
            name: 'cp_total_cart_items',
            description:
              'Περιέχει την τρέχουσα κατάσταση καλαθιού του επισκέπτη με τον τρέχοντα αριθμό στοιχείων που περιέχει.',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12 μήνες',
            name: 'IDE',
            description:
              'Τα cookie DoubleClick IDE χρησιμοποιούνται για την προβολή στοχευμένων διαφημίσεων που σχετίζονται με τους χρήστες στον ιστό.',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12 μήνες',
            name: '_gcl_au',
            description:
              'Χρησιμοποιείται από το Google AdSense για πειραματισμό με την αποτελεσματικότητα της διαφήμισης σε ιστότοπους που χρησιμοποιούν τις υπηρεσίες τους.',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28 μέρες',
            name: '_fbp',
            description: 'Το fbp χρησιμοποιείται για τη διάκριση και την παρακολούθηση των μοναδικών χρηστών σας.',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12 μήνες',
            name: 'IDE',
            description:
              'Τα cookie DoubleClick IDE χρησιμοποιούνται για την προβολή στοχευμένων διαφημίσεων που σχετίζονται με τους χρήστες στον ιστό.',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12 μήνες',
            name: '_gcl_au',
            description:
              'Χρησιμοποιείται από το Google AdSense για πειραματισμό με την αποτελεσματικότητα της διαφήμισης σε ιστότοπους που χρησιμοποιούν τις υπηρεσίες τους.',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28 μέρες',
            name: '_fbp',
            description: 'Το fbp χρησιμοποιείται για τη διάκριση και την παρακολούθηση των μοναδικών χρηστών σας.',
            origin: 'Facebook',
          },
        ],
    cookieFunctional: [
      {
        id: 1,
        duration: 'until deleted by user (delete cache)',
        name: 'sortOption',
        description: 'Διατηρεί την επιλογή του χρήστη  όσον αφορά την προβολή προϊόντων με βάση φίλτρο',
        origin: process.env.appName,
      },
    ],
  },
  en: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: 'session',
        name: 'PHPSESSID',
        description: 'It maintains the state of the user connection across all page requests.',
        origin: process.env.appName,
      },
      // {
      //   id: 2,
      //   duration: '12 μήνες',
      //   name: '__zlcmid',
      //   description: 'Χρησιμοποιείται για την άμεση επικοινωνία με το customer support.',
      //   origin: process.env.appName,
      // },
      {
        id: 3,
        duration: '15 days',
        name: 'token',
        description: 'Maintains the users login status on the website',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: 'session',
        name: 'JSESSIONID',
        description: 'Maintains the users choice for the use of cookies',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: 'until deleted by user (delete cache)',
        name: 'productForOrder',
        description: 'Keeps the products in the users order cart',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: 'until deleted by user (delete cache)',
        name: 'productQuantities',
        description: 'It maintains the quantities of the products in the users order basket',
        origin: process.env.appName,
      },
      // {
      //   id: 7,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'order',
      //   description: 'Διατηρεί τις επιλογές του χρήστη  όσον αφορά την παραγγελίας του',
      //   origin: process.env.appName,
      // },
      // {
      //   id: 8,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'DeliveryMode',
      //   description: 'Διατηρεί την επιλογή του χρήστη  όσον αφορά την υπηρεσία',
      //   origin: process.env.appName,
      // },
      {
        id: 9,
        duration: 'until deleted by user (delete cache)',
        name: 'PostalCode',
        description: 'It retains the users choice of zip code to view available services',
        origin: process.env.appName,
      },
      // {
      //   id: 10,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'isAddressRegistered',
      //   description: 'Διατηρεί αν ο χρήστης έχει υποβάλει πληροφορίες για τον ταχυδρομικό του κώδικα',
      //   origin: process.env.appName,
      // },
      {
        id: 11,
        duration: 'until deleted by user (delete cache)',
        name: `${process.env.appName}:privacy`,
        description: 'It preserves the users choices for accepting cookies',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: 'until deleted by user (delete cache)',
        name: 'Shop',
        description: 'Maintains the store that serves the user',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: 'until deleted by user (delete cache)',
        name: 'loginProvider',
        description: 'Maintains how the user entered the application',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: 'until deleted by user (delete cache)',
        name: 'pickupMethod',
        description: 'Maintains the users choice of delivery/pickup service',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrer',
        description: 'Detects how the user reached the website by registering their last URL-address.	',

        origin: '	Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrerTime',
        description: 'Detects how the user reached the website by registering their last URL-address.	',

        origin: '	Meta Platforms, Inc.',
      },
      {
        id: 18,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedUserAddressIndex',
        description: 'Preserves the users address selection',
        origin: process.env.appName,
      },
      {
        id: 19,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedTakeAwayStoreIndex',
        description: 'Preserves the users shop selection',
        origin: process.env.appName,
      },
      {
        id: 20,
        duration: 'until deleted by user (delete cache)',
        name: 'generalSelectedTimeslot',
        description: 'Preserves the users timeslot selection',
        origin: process.env.appName,
      },
      {
        id: 21,
        duration: 'until deleted by user (delete cache)',
        name: 'SelectedShopId',
        description: 'Keeps the id of the store that serves the user',
        origin: process.env.appName,
      },
      {
        id: 22,
        duration: 'until deleted by user (delete cache)',
        name: 'user',
        description: 'Maintains information about the users account',
        origin: process.env.appName,
      },
      {
        id: 23,
        duration: 'until deleted by user (delete cache)',
        name: 'prebook',
        description: 'Holds information about the users pre booked timeslot',
        origin: process.env.appName,
      },
      {
        id: 24,
        duration: 'until deleted by user (delete cache)',
        name: 'firstSelectedTimeslot',
        description: 'Preserves the users timeslot selection',
        origin: process.env.appName,
      },
      {
        id: 25,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedBundleOffer',
        description: 'Retains the users choice of bundle offer',
        origin: process.env.appName,
      },
      {
        id: 26,
        duration: 'until deleted by user (delete cache)',
        name: 'cart',
        description: 'Maintains information regarding the cart prepared by the user',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: 'session',
        name: '_gat_UA-105613924-4',
        description: 'Registers a unique identifier for the website company',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2 days',
        name: '_gid',
        description:
          'Registers a unique identifier that is used to generate statistics about how the visitor uses the website.',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24 months',
        name: '_ga',
        description: 'Used by Google Analytics to adjust request speed',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6 months',
        name: 'NID',
        description:
          'The NID cookie contains a unique identifier that Google uses to remember your preferences and other information.',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24 months',
        name: 'CONSENT',
        description:
          'The consent feature allows you to customize how your tags behave on Google based on the consent status of your users.',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30 days',
        name: '1P_JAR',
        description: 'These cookies are used to collect website statistics and track conversion rates.',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1 day',
        name: 'DV',
        description: 'This cookie is used to store user preferences and other information.',
        origin: 'Google',
      },
    ],
    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12 months',
            name: 'bi',
            description: 'Used as the identification string for the visitors session. It is a GUID string.',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12 months',
            name: 'cpab',
            description: 'This cookie works to provide you with a personalized experience in the Store.',
            origin: 'Contact Pigeon',
          },
          {
            id: 3,
            duration: '12 months',
            name: 'cp_sessionTime',
            description: 'Contains the timestamp of the visitors last visited page in milliseconds.',
            origin: 'Contact Pigeon',
          },
          {
            id: 4,
            duration: '12 months',
            name: 'cp_total_cart_value',
            description:
              'Contains the current cart state of the visitor with the current content containing the total value.',
            origin: 'Contact Pigeon',
          },
          {
            id: 5,
            duration: 'Session',
            name: 'cp_shownnotscookie',
            description: 'It keeps information about whether the user wants notifications in his browser',
            origin: 'Contact Pigeon',
          },
          {
            id: 6,
            duration: '12 months',
            name: 'cp_total_cart_items',
            description: 'Contains the visitors current cart status with the current number of items it contains.',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12 months',
            name: 'IDE',
            description: 'DoubleClick IDE cookies are used to serve targeted ads relevant to users on the web.',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12 months',
            name: '_gcl_au',
            description:
              'Used by Google AdSense to experiment with the effectiveness of advertising on websites using their services.',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28 days',
            name: '_fbp',
            description: 'fbp is used to distinguish and track unique users.',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12 months',
            name: 'IDE',
            description: 'DoubleClick IDE cookies are used to serve targeted ads relevant to users on the web.',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12 months',
            name: '_gcl_au',
            description:
              'Used by Google AdSense to experiment with the effectiveness of advertising on websites using their services.',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28 days',
            name: '_fbp',
            description: 'fbp is used to distinguish and track unique users.',
            origin: 'Facebook',
          },
        ],
    cookieFunctional: [
      {
        id: 1,
        duration: 'until deleted by user (delete cache)',
        name: 'sortOption',
        description: 'It preserves the users choice of displaying products based on a filter',
        origin: process.env.appName,
      },
    ],
  },
  cn: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: '会话',
        name: 'PHPSESSID',
        description: '保持用户会话状态，以便在所有页面请求中维持登录状态。',
        origin: process.env.appName,
      },
      {
        id: 3,
        duration: '15天',
        name: 'token',
        description: '保持用户在网站上的登录状态',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: '会话',
        name: 'JSESSIONID',
        description: '保持用户对 Cookie 使用的选择',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: '直到用户删除（清除缓存）',
        name: 'productForOrder',
        description: '保持用户购物车中的产品',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: '直到用户删除（清除缓存）',
        name: 'productQuantities',
        description: '保持用户购物车中的产品数量',
        origin: process.env.appName,
      },
      {
        id: 9,
        duration: '直到用户删除（清除缓存）',
        name: 'PostalCode',
        description: '保留用户选择的邮政编码，以便查看可用的服务',
        origin: process.env.appName,
      },
      {
        id: 11,
        duration: '直到用户删除（清除缓存）',
        name: `${process.env.appName}:privacy`,
        description: '保留用户接受 Cookie 的选择',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: '直到用户删除（清除缓存）',
        name: 'Shop',
        description: '保持用户所选择的服务商店',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: '直到用户删除（清除缓存）',
        name: 'loginProvider',
        description: '保持用户的登录方式',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: '直到用户删除（清除缓存）',
        name: 'pickupMethod',
        description: '保持用户的配送/取货方式选择',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: '直到用户删除（清除缓存）',
        name: 'lastExternalReferrer',
        description: '检测用户如何到达网站，记录其最后的 URL 地址',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: '直到用户删除（清除缓存）',
        name: 'lastExternalReferrerTime',
        description: '检测用户如何到达网站，记录其最后的 URL 地址',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 26,
        duration: '直到用户删除（清除缓存）',
        name: 'cart',
        description: '保持用户准备的购物车信息',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: '会话',
        name: '_gat_UA-105613924-4',
        description: '为网站公司注册一个唯一的标识符',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2天',
        name: '_gid',
        description: '注册唯一标识符，用于生成关于访问者如何使用网站的统计数据。',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24个月',
        name: '_ga',
        description: '由 Google Analytics 用于调整请求速度',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6个月',
        name: 'NID',
        description: 'NID Cookie 包含 Google 用于记住您的偏好和其他信息的唯一标识符。',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24个月',
        name: 'CONSENT',
        description: '同意功能允许您根据用户的同意状态自定义 Google 标签的行为。',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30天',
        name: '1P_JAR',
        description: '这些 Cookie 用于收集网站统计数据并跟踪转化率。',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1天',
        name: 'DV',
        description: '此 Cookie 用于存储用户偏好和其他信息。',
        origin: 'Google',
      },
    ],

    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12个月',
            name: 'bi',
            description: '用于识别访问者会话的唯一字符串。它是一个 GUID 字符串。',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12个月',
            name: 'cpab',
            description: '此 Cookie 用于提供个性化的在线购物体验。',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12个月',
            name: 'IDE',
            description: 'DoubleClick IDE Cookie 用于向用户投放相关的个性化广告。',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12个月',
            name: '_gcl_au',
            description: '由 Google AdSense 用于测试广告的有效性。',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28天',
            name: '_fbp',
            description: '_fbp 用于区分和跟踪唯一用户。',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12个月',
            name: 'IDE',
            description: 'DoubleClick IDE Cookie 用于向用户投放相关的个性化广告。',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12个月',
            name: '_gcl_au',
            description: '由 Google AdSense 用于测试广告的有效性。',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28天',
            name: '_fbp',
            description: '_fbp 用于区分和跟踪唯一用户。',
            origin: 'Facebook',
          },
        ],

    cookieFunctional: [
      {
        id: 1,
        duration: '直到用户删除（清除缓存）',
        name: 'sortOption',
        description: '保留用户选择的产品排序方式',
        origin: process.env.appName,
      },
    ],
  },
  ro: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: 'session',
        name: 'PHPSESSID',
        description: 'It maintains the state of the user connection across all page requests.',
        origin: process.env.appName,
      },
      // {
      //   id: 2,
      //   duration: '12 μήνες',
      //   name: '__zlcmid',
      //   description: 'Χρησιμοποιείται για την άμεση επικοινωνία με το customer support.',
      //   origin: process.env.appName,
      // },
      {
        id: 3,
        duration: '15 days',
        name: 'token',
        description: 'Maintains the users login status on the website',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: 'session',
        name: 'JSESSIONID',
        description: 'Maintains the users choice for the use of cookies',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: 'until deleted by user (delete cache)',
        name: 'productForOrder',
        description: 'Keeps the products in the users order cart',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: 'until deleted by user (delete cache)',
        name: 'productQuantities',
        description: 'It maintains the quantities of the products in the users order basket',
        origin: process.env.appName,
      },
      // {
      //   id: 7,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'order',
      //   description: 'Διατηρεί τις επιλογές του χρήστη  όσον αφορά την παραγγελίας του',
      //   origin: process.env.appName,
      // },
      // {
      //   id: 8,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'DeliveryMode',
      //   description: 'Διατηρεί την επιλογή του χρήστη  όσον αφορά την υπηρεσία',
      //   origin: process.env.appName,
      // },
      {
        id: 9,
        duration: 'until deleted by user (delete cache)',
        name: 'PostalCode',
        description: 'It retains the users choice of zip code to view available services',
        origin: process.env.appName,
      },
      // {
      //   id: 10,
      //   duration: 'until deleted by user (delete cache)',
      //   name: 'isAddressRegistered',
      //   description: 'Διατηρεί αν ο χρήστης έχει υποβάλει πληροφορίες για τον ταχυδρομικό του κώδικα',
      //   origin: process.env.appName,
      // },
      {
        id: 11,
        duration: 'until deleted by user (delete cache)',
        name: `${process.env.appName}:privacy`,
        description: 'It preserves the users choices for accepting cookies',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: 'until deleted by user (delete cache)',
        name: 'Shop',
        description: 'Maintains the store that serves the user',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: 'until deleted by user (delete cache)',
        name: 'loginProvider',
        description: 'Maintains how the user entered the application',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: 'until deleted by user (delete cache)',
        name: 'pickupMethod',
        description: 'Maintains the users choice of delivery/pickup service',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrer',
        description: 'Detects how the user reached the website by registering their last URL-address.	',

        origin: '	Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrerTime',
        description: 'Detects how the user reached the website by registering their last URL-address.	',

        origin: '	Meta Platforms, Inc.',
      },
      {
        id: 18,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedUserAddressIndex',
        description: 'Preserves the users address selection',
        origin: process.env.appName,
      },
      {
        id: 19,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedTakeAwayStoreIndex',
        description: 'Preserves the users shop selection',
        origin: process.env.appName,
      },
      {
        id: 20,
        duration: 'until deleted by user (delete cache)',
        name: 'generalSelectedTimeslot',
        description: 'Preserves the users timeslot selection',
        origin: process.env.appName,
      },
      {
        id: 21,
        duration: 'until deleted by user (delete cache)',
        name: 'SelectedShopId',
        description: 'Keeps the id of the store that serves the user',
        origin: process.env.appName,
      },
      {
        id: 22,
        duration: 'until deleted by user (delete cache)',
        name: 'user',
        description: 'Maintains information about the users account',
        origin: process.env.appName,
      },
      {
        id: 23,
        duration: 'until deleted by user (delete cache)',
        name: 'prebook',
        description: 'Holds information about the users pre booked timeslot',
        origin: process.env.appName,
      },
      {
        id: 24,
        duration: 'until deleted by user (delete cache)',
        name: 'firstSelectedTimeslot',
        description: 'Preserves the users timeslot selection',
        origin: process.env.appName,
      },
      {
        id: 25,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedBundleOffer',
        description: 'Retains the users choice of bundle offer',
        origin: process.env.appName,
      },
      {
        id: 26,
        duration: 'until deleted by user (delete cache)',
        name: 'cart',
        description: 'Maintains information regarding the cart prepared by the user',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: 'session',
        name: '_gat_UA-105613924-4',
        description: 'Registers a unique identifier for the website company',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2 days',
        name: '_gid',
        description:
          'Registers a unique identifier that is used to generate statistics about how the visitor uses the website.',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24 months',
        name: '_ga',
        description: 'Used by Google Analytics to adjust request speed',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6 months',
        name: 'NID',
        description:
          'The NID cookie contains a unique identifier that Google uses to remember your preferences and other information.',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24 months',
        name: 'CONSENT',
        description:
          'The consent feature allows you to customize how your tags behave on Google based on the consent status of your users.',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30 days',
        name: '1P_JAR',
        description: 'These cookies are used to collect website statistics and track conversion rates.',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1 day',
        name: 'DV',
        description: 'This cookie is used to store user preferences and other information.',
        origin: 'Google',
      },
    ],
    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12 months',
            name: 'bi',
            description: 'Used as the identification string for the visitors session. It is a GUID string.',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12 months',
            name: 'cpab',
            description: 'This cookie works to provide you with a personalized experience in the Store.',
            origin: 'Contact Pigeon',
          },
          {
            id: 3,
            duration: '12 months',
            name: 'cp_sessionTime',
            description: 'Contains the timestamp of the visitors last visited page in milliseconds.',
            origin: 'Contact Pigeon',
          },
          {
            id: 4,
            duration: '12 months',
            name: 'cp_total_cart_value',
            description:
              'Contains the current cart state of the visitor with the current content containing the total value.',
            origin: 'Contact Pigeon',
          },
          {
            id: 5,
            duration: 'Session',
            name: 'cp_shownnotscookie',
            description: 'It keeps information about whether the user wants notifications in his browser',
            origin: 'Contact Pigeon',
          },
          {
            id: 6,
            duration: '12 months',
            name: 'cp_total_cart_items',
            description: 'Contains the visitors current cart status with the current number of items it contains.',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12 months',
            name: 'IDE',
            description: 'DoubleClick IDE cookies are used to serve targeted ads relevant to users on the web.',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12 months',
            name: '_gcl_au',
            description:
              'Used by Google AdSense to experiment with the effectiveness of advertising on websites using their services.',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28 days',
            name: '_fbp',
            description: 'fbp is used to distinguish and track unique users.',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12 months',
            name: 'IDE',
            description: 'DoubleClick IDE cookies are used to serve targeted ads relevant to users on the web.',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12 months',
            name: '_gcl_au',
            description:
              'Used by Google AdSense to experiment with the effectiveness of advertising on websites using their services.',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28 days',
            name: '_fbp',
            description: 'fbp is used to distinguish and track unique users.',
            origin: 'Facebook',
          },
        ],
    cookieFunctional: [
      {
        id: 1,
        duration: 'until deleted by user (delete cache)',
        name: 'sortOption',
        description: 'It preserves the users choice of displaying products based on a filter',
        origin: process.env.appName,
      },
    ],
  },
  es: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: 'sesión',
        name: 'PHPSESSID',
        description: 'Mantiene el estado de la conexión del usuario a través de todas las solicitudes de página.',
        origin: process.env.appName,
      },
      {
        id: 3,
        duration: '15 días',
        name: 'token',
        description: 'Mantiene el estado de inicio de sesión de los usuarios en el sitio web',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: 'sesión',
        name: 'JSESSIONID',
        description: 'Mantiene la elección del usuario para el uso de cookies',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'productForOrder',
        description: 'Mantiene los productos en el carrito de pedido del usuario',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'productQuantities',
        description: 'Mantiene las cantidades de los productos en el carrito de pedidos del usuario',
        origin: process.env.appName,
      },
      {
        id: 9,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'PostalCode',
        description: 'Conserva la elección del usuario de código postal para ver servicios disponibles',
        origin: process.env.appName,
      },
      {
        id: 11,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: `${process.env.appName}:privacy`,
        description: 'Preserva las elecciones del usuario para aceptar cookies',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'Shop',
        description: 'Mantiene la tienda que atiende al usuario',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'loginProvider',
        description: 'Mantiene cómo el usuario ingresó a la aplicación',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'pickupMethod',
        description: 'Mantiene la elección del usuario de servicio de entrega/recogida',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'lastExternalReferrer',
        description: 'Detecta cómo llegó el usuario al sitio registrando su última dirección URL.',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'lastExternalReferrerTime',
        description: 'Detecta cómo llegó el usuario al sitio registrando la hora de su última dirección URL.',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 18,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'selectedUserAddressIndex',
        description: 'Preserva la selección de dirección del usuario',
        origin: process.env.appName,
      },
      {
        id: 19,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'selectedTakeAwayStoreIndex',
        description: 'Preserva la selección de tienda para llevar del usuario',
        origin: process.env.appName,
      },
      {
        id: 20,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'generalSelectedTimeslot',
        description: 'Preserva la selección de franja horaria del usuario',
        origin: process.env.appName,
      },
      {
        id: 21,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'SelectedShopId',
        description: 'Mantiene el ID de la tienda que atiende al usuario',
        origin: process.env.appName,
      },
      {
        id: 22,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'user',
        description: 'Mantiene información sobre la cuenta del usuario',
        origin: process.env.appName,
      },
      {
        id: 23,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'prebook',
        description: 'Guarda información sobre la franja horaria pre-reservada del usuario',
        origin: process.env.appName,
      },
      {
        id: 24,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'firstSelectedTimeslot',
        description: 'Preserva la primera selección de franja horaria del usuario',
        origin: process.env.appName,
      },
      {
        id: 25,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'selectedBundleOffer',
        description: 'Conserva la elección de oferta de paquete del usuario',
        origin: process.env.appName,
      },
      {
        id: 26,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'cart',
        description: 'Mantiene información sobre el carrito preparado por el usuario',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: 'sesión',
        name: '_gat_UA-105613924-4',
        description: 'Registra un identificador único para la empresa del sitio web',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2 días',
        name: '_gid',
        description:
          'Registra un identificador único que se utiliza para generar estadísticas sobre cómo el visitante usa el sitio web.',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24 meses',
        name: '_ga',
        description: 'Utilizado por Google Analytics para ajustar la velocidad de las solicitudes',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6 meses',
        name: 'NID',
        description:
          'La cookie NID contiene un identificador único que Google utiliza para recordar sus preferencias y otra información.',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24 meses',
        name: 'CONSENT',
        description:
          'La función de consentimiento le permite personalizar cómo se comportan sus etiquetas en Google según el estado de consentimiento de sus usuarios.',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30 días',
        name: '1P_JAR',
        description: 'Estas cookies se usan para recopilar estadísticas del sitio web y rastrear tasas de conversión.',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1 día',
        name: 'DV',
        description: 'Esta cookie se utiliza para almacenar preferencias del usuario y otra información.',
        origin: 'Google',
      },
    ],

    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12 meses',
            name: 'bi',
            description: 'Se usa como cadena de identificación para la sesión de los visitantes. Es una cadena GUID.',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12 meses',
            name: 'cpab',
            description: 'Esta cookie funciona para brindarle una experiencia personalizada en la Tienda.',
            origin: 'Contact Pigeon',
          },
          {
            id: 3,
            duration: '12 meses',
            name: 'cp_sessionTime',
            description: 'Contiene la marca de tiempo de la última página visitada por el visitante en milisegundos.',
            origin: 'Contact Pigeon',
          },
          {
            id: 4,
            duration: '12 meses',
            name: 'cp_total_cart_value',
            description: 'Contiene el estado actual del carrito del visitante con el valor total actual.',
            origin: 'Contact Pigeon',
          },
          {
            id: 5,
            duration: 'sesión',
            name: 'cp_shownnotscookie',
            description: 'Mantiene información sobre si el usuario desea notificaciones en su navegador',
            origin: 'Contact Pigeon',
          },
          {
            id: 6,
            duration: '12 meses',
            name: 'cp_total_cart_items',
            description:
              'Contiene el estado actual del carrito del visitante con el número actual de artículos que contiene.',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12 meses',
            name: 'IDE',
            description:
              'Las cookies IDE de DoubleClick se utilizan para mostrar anuncios personalizados relevantes para los usuarios en la web.',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12 meses',
            name: '_gcl_au',
            description:
              'Utilizado por Google AdSense para experimentar con la efectividad de la publicidad en sitios web que utilizan sus servicios.',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28 días',
            name: '_fbp',
            description: 'Se usa para distinguir y rastrear usuarios únicos.',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12 meses',
            name: 'IDE',
            description:
              'Las cookies IDE de DoubleClick se utilizan para mostrar anuncios personalizados relevantes para los usuarios en la web.',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12 meses',
            name: '_gcl_au',
            description:
              'Utilizado por Google AdSense para experimentar con la efectividad de la publicidad en sitios web que utilizan sus servicios.',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28 días',
            name: '_fbp',
            description: 'Se usa para distinguir y rastrear usuarios únicos.',
            origin: 'Facebook',
          },
        ],

    cookieFunctional: [
      {
        id: 1,
        duration: 'hasta que el usuario lo elimine (borrar caché)',
        name: 'sortOption',
        description: 'Conserva la elección del usuario de mostrar productos según un filtro',
        origin: process.env.appName,
      },
    ],
  },
  pt: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: 'sessão',
        name: 'PHPSESSID',
        description: 'Mantém o estado da ligação do utilizador em todos os pedidos de página.',
        origin: process.env.appName,
      },
      {
        id: 3,
        duration: '15 dias',
        name: 'token',
        description: 'Mantém o estado de início de sessão do utilizador no website',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: 'sessão',
        name: 'JSESSIONID',
        description: 'Mantém a escolha do utilizador quanto à utilização de cookies',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'productForOrder',
        description: 'Mantém os produtos no carrinho de encomenda do utilizador',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'productQuantities',
        description: 'Mantém as quantidades dos produtos no carrinho do utilizador',
        origin: process.env.appName,
      },
      {
        id: 9,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'PostalCode',
        description: 'Conserva a escolha de código postal do utilizador para apresentar os serviços disponíveis',
        origin: process.env.appName,
      },
      {
        id: 11,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: `${process.env.appName}:privacy`,
        description: 'Conserva as escolhas do utilizador quanto à aceitação de cookies',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'Shop',
        description: 'Mantém a loja que serve o utilizador',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'loginProvider',
        description: 'Mantém o método de início de sessão do utilizador na aplicação',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'pickupMethod',
        description: 'Mantém a escolha do utilizador do serviço de entrega/levantamento',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'lastExternalReferrer',
        description: 'Deteta como o utilizador chegou ao website, registando o último URL.',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'lastExternalReferrerTime',
        description: 'Deteta como o utilizador chegou ao website, registando o último URL.',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 18,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'selectedUserAddressIndex',
        description: 'Conserva a seleção de morada do utilizador',
        origin: process.env.appName,
      },
      {
        id: 19,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'selectedTakeAwayStoreIndex',
        description: 'Conserva a seleção de loja do utilizador',
        origin: process.env.appName,
      },
      {
        id: 20,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'generalSelectedTimeslot',
        description: 'Conserva a seleção de janela horária (timeslot) do utilizador',
        origin: process.env.appName,
      },
      {
        id: 21,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'SelectedShopId',
        description: 'Mantém o ID da loja que serve o utilizador',
        origin: process.env.appName,
      },
      {
        id: 22,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'user',
        description: 'Mantém informação sobre a conta do utilizador',
        origin: process.env.appName,
      },
      {
        id: 23,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'prebook',
        description: 'Guarda informação sobre a janela horária pré-marcada do utilizador',
        origin: process.env.appName,
      },
      {
        id: 24,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'firstSelectedTimeslot',
        description: 'Conserva a primeira seleção de janela horária do utilizador',
        origin: process.env.appName,
      },
      {
        id: 25,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'selectedBundleOffer',
        description: 'Conserva a escolha de oferta combinada do utilizador',
        origin: process.env.appName,
      },
      {
        id: 26,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'cart',
        description: 'Mantém informação sobre o carrinho preparado pelo utilizador',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: 'sessão',
        name: '_gat_UA-105613924-4',
        description: 'Regista um identificador único para a empresa do website',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2 dias',
        name: '_gid',
        description:
          'Regista um identificador único que é usado para gerar estatísticas sobre como o visitante utiliza o website.',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24 meses',
        name: '_ga',
        description: 'Utilizado pelo Google Analytics para ajustar a velocidade dos pedidos',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6 meses',
        name: 'NID',
        description:
          'O cookie NID contém um identificador único que a Google usa para recordar as suas preferências e outras informações.',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24 meses',
        name: 'CONSENT',
        description:
          'A funcionalidade de consentimento permite personalizar o comportamento das suas tags na Google com base no estado de consentimento dos seus utilizadores.',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30 dias',
        name: '1P_JAR',
        description:
          'Estes cookies são utilizados para recolher estatísticas do website e para acompanhar taxas de conversão.',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1 dia',
        name: 'DV',
        description: 'Este cookie é utilizado para guardar as preferências do utilizador e outras informações.',
        origin: 'Google',
      },
    ],

    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12 meses',
            name: 'bi',
            description: 'Utilizado como cadeia de identificação da sessão do visitante. É uma cadeia GUID.',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12 meses',
            name: 'cpab',
            description: 'Este cookie funciona para lhe proporcionar uma experiência personalizada na Loja.',
            origin: 'Contact Pigeon',
          },
          {
            id: 3,
            duration: '12 meses',
            name: 'cp_sessionTime',
            description: 'Contém a marca temporal da última página visitada pelo visitante, em milissegundos.',
            origin: 'Contact Pigeon',
          },
          {
            id: 4,
            duration: '12 meses',
            name: 'cp_total_cart_value',
            description: 'Contém o estado atual do carrinho do visitante com o conteúdo atual incluindo o valor total.',
            origin: 'Contact Pigeon',
          },
          {
            id: 5,
            duration: 'sessão',
            name: 'cp_shownnotscookie',
            description: 'Mantém informação sobre se o utilizador pretende notificações no seu navegador',
            origin: 'Contact Pigeon',
          },
          {
            id: 6,
            duration: '12 meses',
            name: 'cp_total_cart_items',
            description: 'Contém o estado atual do carrinho do visitante com o número atual de itens que contém.',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12 meses',
            name: 'IDE',
            description:
              'Os cookies DoubleClick IDE são utilizados para apresentar anúncios direcionados relevantes na Web.',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12 meses',
            name: '_gcl_au',
            description:
              'Utilizado pelo Google AdSense para experimentar a eficácia da publicidade em websites que usam os seus serviços.',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28 dias',
            name: '_fbp',
            description: '_fbp é utilizado para distinguir e rastrear utilizadores únicos.',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12 meses',
            name: 'IDE',
            description:
              'Os cookies DoubleClick IDE são utilizados para apresentar anúncios direcionados relevantes na Web.',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12 meses',
            name: '_gcl_au',
            description:
              'Utilizado pelo Google AdSense para experimentar a eficácia da publicidade em websites que usam os seus serviços.',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28 dias',
            name: '_fbp',
            description: '_fbp é utilizado para distinguir e rastrear utilizadores únicos.',
            origin: 'Facebook',
          },
        ],

    cookieFunctional: [
      {
        id: 1,
        duration: 'até ser eliminado pelo utilizador (limpar cache)',
        name: 'sortOption',
        description: 'Conserva a escolha do utilizador de apresentar produtos com base num filtro',
        origin: process.env.appName,
      },
    ],
  },
  ar: {
    cookieModelNecessary: [
      {
        id: 1,
        duration: 'session',
        name: 'PHPSESSID',
        description: 'يحافظ على حالة اتصال المستخدم عبر جميع طلبات الصفحة.',
        origin: process.env.appName,
      },
      {
        id: 3,
        duration: '15 days',
        name: 'token',
        description: 'يحافظ على حالة تسجيل دخول المستخدم في الموقع.',
        origin: process.env.appName,
      },
      {
        id: 4,
        duration: 'session',
        name: 'JSESSIONID',
        description: 'يحافظ على اختيار المستخدم بخصوص استخدام ملفات تعريف الارتباط.',
        origin: process.env.appName,
      },
      {
        id: 5,
        duration: 'until deleted by user (delete cache)',
        name: 'productForOrder',
        description: 'يحتفظ بالمنتجات الموجودة في سلة طلب المستخدم.',
        origin: process.env.appName,
      },
      {
        id: 6,
        duration: 'until deleted by user (delete cache)',
        name: 'productQuantities',
        description: 'يحافظ على كميات المنتجات في سلة طلب المستخدم.',
        origin: process.env.appName,
      },
      {
        id: 9,
        duration: 'until deleted by user (delete cache)',
        name: 'PostalCode',
        description: 'يحتفظ باختيار المستخدم للرمز البريدي لعرض الخدمات المتاحة.',
        origin: process.env.appName,
      },
      {
        id: 11,
        duration: 'until deleted by user (delete cache)',
        name: '${process.env.appName}:privacy',
        description: 'يحافظ على اختيارات المستخدم المتعلقة بقبول ملفات تعريف الارتباط.',
        origin: process.env.appName,
      },
      {
        id: 12,
        duration: 'until deleted by user (delete cache)',
        name: 'Shop',
        description: 'يحافظ على المتجر الذي يخدم المستخدم.',
        origin: process.env.appName,
      },
      {
        id: 13,
        duration: 'until deleted by user (delete cache)',
        name: 'loginProvider',
        description: 'يحافظ على كيفية دخول المستخدم إلى التطبيق.',
        origin: process.env.appName,
      },
      {
        id: 15,
        duration: 'until deleted by user (delete cache)',
        name: 'pickupMethod',
        description: 'يحافظ على اختيار المستخدم لخدمة التوصيل/الاستلام.',
        origin: process.env.appName,
      },
      {
        id: 16,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrer',
        description: 'يكتشف كيفية وصول المستخدم إلى الموقع من خلال تسجيل آخر عنوان URL زاره.',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 17,
        duration: 'until deleted by user (delete cache)',
        name: 'lastExternalReferrerTime',
        description: 'يكتشف كيفية وصول المستخدم إلى الموقع من خلال تسجيل آخر عنوان URL زاره.',
        origin: 'Meta Platforms, Inc.',
      },
      {
        id: 18,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedUserAddressIndex',
        description: 'يحافظ على اختيار المستخدم لعنوانه.',
        origin: process.env.appName,
      },
      {
        id: 19,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedTakeAwayStoreIndex',
        description: 'يحافظ على اختيار المستخدم للمتجر.',
        origin: process.env.appName,
      },
      {
        id: 20,
        duration: 'until deleted by user (delete cache)',
        name: 'generalSelectedTimeslot',
        description: 'يحافظ على اختيار المستخدم للفترة الزمنية.',
        origin: process.env.appName,
      },
      {
        id: 21,
        duration: 'until deleted by user (delete cache)',
        name: 'SelectedShopId',
        description: 'يحتفظ برقم المتجر الذي يخدم المستخدم.',
        origin: process.env.appName,
      },
      {
        id: 22,
        duration: 'until deleted by user (delete cache)',
        name: 'user',
        description: 'يحافظ على معلومات حساب المستخدم.',
        origin: process.env.appName,
      },
      {
        id: 23,
        duration: 'until deleted by user (delete cache)',
        name: 'prebook',
        description: 'يحتفظ بمعلومات عن الفترة الزمنية المحجوزة مسبقًا للمستخدم.',
        origin: process.env.appName,
      },
      {
        id: 24,
        duration: 'until deleted by user (delete cache)',
        name: 'firstSelectedTimeslot',
        description: 'يحافظ على اختيار المستخدم للفترة الزمنية.',
        origin: process.env.appName,
      },
      {
        id: 25,
        duration: 'until deleted by user (delete cache)',
        name: 'selectedBundleOffer',
        description: 'يحتفظ باختيار المستخدم للعرض التجميعي.',
        origin: process.env.appName,
      },
      {
        id: 26,
        duration: 'until deleted by user (delete cache)',
        name: 'cart',
        description: 'يحافظ على المعلومات المتعلقة بسلة المشتريات التي أعدها المستخدم.',
        origin: process.env.appName,
      },
    ],

    cookiePerformance: [
      {
        id: 1,
        duration: 'session',
        name: '_gat_UA-105613924-4',
        description: 'يسجل معرفًا فريدًا لشركة الموقع.',
        origin: 'Google',
      },
      {
        id: 2,
        duration: '2 days',
        name: '_gid',
        description: 'يسجل معرفًا فريدًا يُستخدم لإنشاء إحصائيات حول كيفية استخدام الزائر للموقع.',
        origin: 'Google',
      },
      {
        id: 3,
        duration: '24 months',
        name: '_ga',
        description: 'يستخدمه Google Analytics لضبط سرعة الطلب.',
        origin: 'Google',
      },
      {
        id: 4,
        duration: '6 months',
        name: 'NID',
        description: 'يحتوي على معرف فريد تستخدمه Google لتذكر تفضيلاتك ومعلومات أخرى.',
        origin: 'Google',
      },
      {
        id: 6,
        duration: '24 months',
        name: 'CONSENT',
        description: 'تتيح لك ميزة الموافقة تخصيص كيفية تصرف علامات Google بناءً على حالة موافقة المستخدم.',
        origin: 'Google',
      },
      {
        id: 8,
        duration: '30 days',
        name: '1P_JAR',
        description: 'تُستخدم هذه الملفات لجمع الإحصاءات وتتبع معدلات التحويل.',
        origin: 'Google',
      },
      {
        id: 9,
        duration: '1 day',
        name: 'DV',
        description: 'يُستخدم هذا الملف لتخزين تفضيلات المستخدم ومعلومات أخرى.',
        origin: 'Google',
      },
    ],

    cookieTargetedAd: process.env.hasContactPigeon
      ? [
          {
            id: 1,
            duration: '12 months',
            name: 'bi',
            description: 'يُستخدم كمعرف لجلسة الزائر، وهو سلسلة GUID.',
            origin: 'Contact Pigeon',
          },
          {
            id: 2,
            duration: '12 months',
            name: 'cpab',
            description: 'يعمل هذا الملف لتوفير تجربة مخصصة لك داخل المتجر.',
            origin: 'Contact Pigeon',
          },
          {
            id: 3,
            duration: '12 months',
            name: 'cp_sessionTime',
            description: 'يحتوي على الطابع الزمني لآخر صفحة زارها المستخدم بالميلي ثانية.',
            origin: 'Contact Pigeon',
          },
          {
            id: 4,
            duration: '12 months',
            name: 'cp_total_cart_value',
            description: 'يحتوي على الحالة الحالية لسلة المستخدم مع القيمة الإجمالية.',
            origin: 'Contact Pigeon',
          },
          {
            id: 5,
            duration: 'Session',
            name: 'cp_shownnotscookie',
            description: 'يحفظ ما إذا كان المستخدم يريد تلقي الإشعارات في المتصفح.',
            origin: 'Contact Pigeon',
          },
          {
            id: 6,
            duration: '12 months',
            name: 'cp_total_cart_items',
            description: 'يحتوي على عدد العناصر الحالية في سلة المستخدم.',
            origin: 'Contact Pigeon',
          },
          {
            id: 7,
            duration: '12 months',
            name: 'IDE',
            description: 'تُستخدم لعرض إعلانات موجهة تتعلق بالمستخدمين عبر الإنترنت.',
            origin: 'doubleclick.net',
          },
          {
            id: 8,
            duration: '12 months',
            name: '_gcl_au',
            description: 'يُستخدم لاختبار فعالية الإعلانات على المواقع.',
            origin: 'Google',
          },
          {
            id: 9,
            duration: '28 days',
            name: '_fbp',
            description: 'يُستخدم لتمييز المستخدمين الفريدين وتتبعهم.',
            origin: 'Facebook',
          },
        ]
      : [
          {
            id: 1,
            duration: '12 months',
            name: 'IDE',
            description: 'تُستخدم ملفات DoubleClick IDE لعرض إعلانات موجهة للمستخدمين.',
            origin: 'doubleclick.net',
          },
          {
            id: 2,
            duration: '12 months',
            name: '_gcl_au',
            description: 'يُستخدم لاختبار فعالية الإعلانات على المواقع.',
            origin: 'Google',
          },
          {
            id: 3,
            duration: '28 days',
            name: '_fbp',
            description: 'يُستخدم لتمييز وتتبع المستخدمين الفريدين.',
            origin: 'Facebook',
          },
        ],

    cookieFunctional: [
      {
        id: 1,
        duration: 'until deleted by user (delete cache)',
        name: 'sortOption',
        description: 'يحافظ على اختيار المستخدم لطريقة عرض المنتجات وفقًا لفلتر معين.',
        origin: process.env.appName,
      },
    ],
  },
};

export default cookies;

export function createTokenCookie(authToken) {
  const cookies = new Cookies();

  const cookieExpirationDate = dayjs().add(15, 'day').toDate();
  cookies.set('token', `${authToken}`, {
    expires: cookieExpirationDate,
    path: '/',
  });
}
